// Libellés et ordre d'affichage des phases dans les listes de symptômes.
//
// Un catalogue statique symptôme → phases vivait ici et servait à regrouper les
// symptômes réellement saisis. « Fatigue » y figurait sous Règles, Folliculaire et
// Lutéale : la saisir une fois pendant les règles la faisait apparaître sous trois
// phases, dont deux non encore vécues — des ressentis semblaient déjà renseignés
// dans le futur. Le regroupement se fait désormais sur la phase du jour de saisie,
// lue dans la timeline (voir Cycle.js et Mental.js).

export const SYMPTOM_PHASE_LABELS = {
  regles:       'Règles',
  folliculaire: 'Folliculaire',
  ovulation:    'Ovulation',
  luteale:      'Lutéale',
};

export const SYMPTOM_PHASE_KEYS = ['regles', 'folliculaire', 'ovulation', 'luteale'];
